import React from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

export default function privacy_policy(props) {
    return (
        <>
            <SEOTAG page="Policies" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    {/* <h2>FAQs</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.privacy_policy,
                        }}
                    ></span>
                </div>
            </Layout>
        </>
    )
}
